import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { EffectsModule } from "@ngrx/effects";
import { StoreModule } from "@ngrx/store";
import Effects from "./+state/effects";
import Facades from "./+state/facades";
import {
  IAM_ACCOUNT_FEATURE_KEY,
  IAM_ACCOUNTS_FEATURE_KEY,
  iamAccountReducer,
  iamAccountsReducer
} from "./+state/reducers";
import Services from "./+state/services";

@NgModule({
  imports: [
    CommonModule,
    EffectsModule.forFeature(Effects),
    StoreModule.forFeature(IAM_ACCOUNT_FEATURE_KEY, iamAccountReducer),
    StoreModule.forFeature(IAM_ACCOUNTS_FEATURE_KEY, iamAccountsReducer)
  ],
  providers: [Facades, Services]
})
export class IamAccountDataAccessModule {}
